import { Flex, Text, FlexProps, HStack } from "@chakra-ui/react";
import React, { ReactNode } from "react";

import { InfoToolTip } from "../../atoms/InfoToolTip";
import { SkeletonRect } from "../../atoms/Skeletons";

interface StatBoxProps extends FlexProps {
  label: string;
  children: ReactNode;
  isLoading: boolean;
  toolTip: string;
}

export function StatBox({
  label,
  children,
  isLoading,
  toolTip,
  ...props
}: StatBoxProps) {
  return (
    <Flex
      w="full"
      px={5}
      py={3}
      direction="column"
      justifyContent="center"
      bgColor="white"
      borderWidth="1px"
      borderColor="gray.300"
      borderRadius="lg"
      overflowX="hidden"
      shadow="sm"
      gap={1}
      {...props}
    >
      <HStack alignItems="center" flexWrap="nowrap">
        <Text fontSize="sm" color="gray.600" noOfLines={1}>
          {label}
        </Text>
        <InfoToolTip label={toolTip} wrap />
      </HStack>
      <SkeletonRect isLoaded={!isLoading}>{children}</SkeletonRect>
    </Flex>
  );
}
